import * as React from 'react'

export interface EngagementInsightsData {
  [key: string]: any
}

const EngagementInsightsContext = React.createContext<EngagementInsightsData | null>(null)

export const EngagementInsightsProvider = ({
  children,
  data,
}: React.PropsWithChildren<{ data: EngagementInsightsData }>) => {
  return (
    <EngagementInsightsContext.Provider value={data}>{children}</EngagementInsightsContext.Provider>
  )
}

export const useEngagementInsightsData = () => {
  const data = React.useContext(EngagementInsightsContext)

  if (!data) {
    throw new Error('Engagement context has no data')
  }

  return data
}
